export default {
  header: {
    accounts: 'Accounts',
    rewards: 'Rewards',
    mundial: 'World Cup 2022',
    whoweare: 'Who we are',
    contact: 'Contact',
    register: 'Register',
    log_in: 'Log In'
  },

  slider: {
    conocer_mas: 'Read more',
    participar: 'Participate',
    slider1text: 'Open your account in United States from anywhere in the world.',
    slider2text: 'Save in dollars and secure your money.',
    slider3text: 'Our rewards program allows you to fly on our private jet fleet.',
    slider4text: 'Fly from Argentina to anywhere in the world.',
    slider5text: 'Travel to the World Cup with the 86\' champions in the Tango D10S. '
  },
  home_page: {
    div_title_h1: 'We are the fintech of the next generation',
    slider1text: 'Abrí tu cuenta en Estados Unidos desde cualquier parte del mundo.',
    top_l_h2t: 'Pay and receive payments easily',
    top_l_p1t: 'From anywhere in the world',
    top_l_h2b: 'FDIC Insured accounts',
    top_l_p2b: 'We partner with a variety of banks and institutions insured by the US Federal Government to offer banking products and services*.',
    top_l2_h2t: 'Multi-currency',
    top_l2_p1t: 'Our accounts allow you to manage multiple foreign currencies.',
    top_l2_h2b: 'Crypto',
    top_l2_p1b: 'Use our wallet to custody and trade cryptocurrencies.',
    calculator_sec_h1: 'Use our calculator to fly from Argentina to anywhere in the world',
    calculator_sec_p: 'Our benefits program allows you to fly on our private jet fleet at incredible prices.',
    cards_card1_h3: 'Jets available',
    cards_card1_p: 'all year',
    cards_card2_h3: 'Flights scheduled',
    cards_card2_p: 'in 48 hours',
    cards_card3_h3: 'Travel alone, with family',
    cards_card3_p: 'or with friends',
    cards_card4_h3: 'Special rates',
    cards_card4_p: 'to fly from Argentina',
    contact_form_home_h1: 'Contact us',
    contact_form_h_label1: 'Name and Last Name',
    contact_form_h_label2: 'Email',
    contact_form_h_label3: 'Message',
    contact_form_btn1: 'Message Sent',
    contact_form_btn2: 'Send',
    footer_link1: 'Accounts',
    footer_link2: 'Rewards',
    footer_link3: 'Who we are',
    footer_link4: 'Contact',
    footer_link5: 'Support',
    footer_link6: 'FAQs',
    footer_disclaimer: '* Give and Get is a trademark of Finanleads LLC. Finanleads LLC is a fintech and not a bank. Finanleads partners with a variety of FDIC-insured banks and institutions to offer banking products and services.',
    copy_r: 'All rights reserved'
  },
  accounts_page: {
    accounts_header_text1: 'PERSONAL',
    accounts_header_text2: 'BUSINESS',
    midd_section_h1: 'US based accounts. A simple and secure platform.',
    midd_section_p: 'Our platform is designed to keep you in control of your finances and manage your money from anywhere in the world.',
    info_s_card1: 'Simple transactions: just a few clicks!',
    info_s_card2: 'Pay and receive payments easily',
    info_s_card3: 'National and international electronic transfers',
    info_s_card4: 'Send and receive ACH payments',
    info_s_card5: 'Send, receive and store digital assets',
    info_s_card6: 'Check deposit and issuance'
  },
  rewards_page: {
    rewards_page_h1: 'Our benefits program provides rewards and benefits on our fleet of private jets.',
    rewards_page_p: 'Fly from Argentina with your family, friends or guests to anywhere in the world.',
    avions_sec_h1: 'Accomplish the dream of traveling to the 2022 World Cup with the 86\' champions in the Tango D10S.',
    bigavion_sec_h1: 'Use the calculator and fly in our fleet of private jets.',
    bigavion_sec_p: 'Our calculator allows you to travel at discounted prices or totally free'
  },
  world_cup_page: {
    mundial_cont_h1: 'Accomplish your dream of traveling to the World Cup in the TANGO D10S',
    mundial_cont_h2: 'With the 1986 champions',
    mundial_cont_p: 'Participate for 1 flight, with tickets for the Argentinian National Team and a complete stay. There are 5 winners! You just have to meet these requirements to participate:',
    mundial_cont_h4: 'REQUIREMENTS',
    mundial_cont_li1: 'Open a PERSONAL or BUSINESS account on giveandget.io',
    mundial_cont_li2: 'If you open a PERSONAL account, you have to deposit at least $2,500 during the first month',
    mundial_cont_li3: 'If you open a BUSINESS account, you have to make an initial deposit of at least $50,000',
    mundial_cont_lip: 'And that\'s it! You are already participating',
    mundial_cont_btn: 'Participate',
    mundial_cont_a: 'See bases and conditions'
  },
  contact_page: {
    contact_page_p: 'For support please contact us at',
    contact_c_form_h1: 'Contact us',
    support_header: 'Support'
  },
  who_we_are_page: {
    who_page_h1: 'We are a fintech that believes in a circular economy.',
    who_page_p: 'We are focused on providing international financial services to our clients with a wide range of solutions that allow a flexible, simple and seamless way to control personal and business finances.',
    who_card1: 'Financial Inclusion',
    who_card1_p: ' We firmly believe that financial inclusion must work together with social inclusion.',
    who_card2: 'Business Awareness',
    who_card2_p: 'We believe that if there is business awareness, there is less dependence on the state.',
    who_card3: 'Dreams',
    who_card3_p: 'We believe that everyone should dream and we want to help fulfill those dreams.',
    who_card4: 'Rewards',
    who_card4_p: 'We believe that people who do good should be rewarded in the same way.',
    box_big_h2: 'About Us',
    box_big_p_1: 'Our team is formed by a group of financial professionals who are highly knowledgeable in the Latin American market and have many partnerships with financial service providers in the United States and throughout South America',
    box_big_p_2: 'They also have extensive experience in financial institutions as well as international trade, real estate investments and aircraft fractional ownership business models.'
  }
}
